import React, { Component } from "react";
import { matchPath } from "react-router";
import slugify from "slugify";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as BenefitsTypesActions } from "store/ducks/benefitsTypes";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Benefits/Types/components";

class Edit extends Component {
  state = {
    data: {
      title: "",
      description: "",
      slug: "",
      active: false,
      automatically_activated: false,
      usable: true,
      transferable: false,
      plan_ids: "",
      segments: [],
      onboarding_only: false,
      onboarding_end_at: null,
      onboarding_start_at: null,
      extra_data: {
        invalidable: false,
        experience_plan_ids: "",
        gift: false,
        transferable_expires_in: "",
        legal_term: "",
      },
    },
    loading: true,
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Lista de Tipos de Benefícios", to: "/benefits/types/list" },
      { name: "Editar", to: "" },
    ],
  };

  componentDidMount() {
    const { getBenefitTypeRequest } = this.props;
    getBenefitTypeRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { benefitType } = this.props;

    if (oldProps.benefitType.loading && !benefitType.loading) {
      const values = {
        id: benefitType.data.id,
        title:
          benefitType.data.attributes.title !== null
            ? benefitType.data.attributes.title
            : "",
        description:
          benefitType.data.attributes.description !== null
            ? benefitType.data.attributes.description
            : "",
        slug:
          benefitType.data.attributes.slug !== null
            ? benefitType.data.attributes.slug
            : "",
        active:
          benefitType.data.attributes.active !== null
            ? benefitType.data.attributes.active
            : false,
        plan_ids: benefitType.data.attributes.extra_data.experience_plan_ids,
        automatically_activated:
          benefitType.data.attributes.automatically_activated !== null
            ? benefitType.data.attributes.automatically_activated
            : false,
        usable: benefitType.data.attributes.usable,
        transferable: benefitType.data.attributes.transferable,
        segments: benefitType.data.attributes.extra_data.segments || [],
        onboarding_only: benefitType.data.attributes.extra_data.onboarding_only,
        onboarding_end_at: benefitType.data.attributes.extra_data
          .onboarding_end_at
          ? new Date(benefitType.data.attributes.extra_data.onboarding_end_at)
          : null,
        onboarding_start_at: benefitType.data.attributes.extra_data
          .onboarding_start_at
          ? new Date(benefitType.data.attributes.extra_data.onboarding_start_at)
          : null,
        extra_data: {
          invalidable:
            benefitType.data.attributes.extra_data.invalidable || false,
          experience_plan_ids:
            benefitType.data.attributes.extra_data.experience_plan_ids,
          gift: benefitType.data.attributes.extra_data.gift,
          transferable_expires_in:
            benefitType.data.attributes.extra_data.transferable_expires_in,
          legal_term: benefitType.data.attributes.extra_data.legal_term,
        },
      };

      this.setState({
        data: values,
        loading: false,
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/benefits/types/:id/edit",
    });
    return match.params.id;
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },
      description: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { updateBenefitsTypesRequest } = this.props;

    updateBenefitsTypesRequest(this.handleGetID(), {
      voucher_configuration: {
        title: data.title,
        description: data.description,
        slug: slugify(data.title, {
          replacement: "-",
          remove: null,
          lower: true,
        }),
        active: data.active,
        automatically_activated: data.automatically_activated,
        usable: data.usable,
        transferable: data.transferable,
        extra_data: {
          onboarding_only: data.onboarding_only,
          onboarding_end_at: data.onboarding_end_at,
          onboarding_start_at: data.onboarding_start_at,
          invalidable: data.extra_data.invalidable,
          experience_plan_ids: data.extra_data.experience_plan_ids,
          segments: data.segments,
          gift: data.extra_data.gift,
          transferable_expires_in: parseInt(
            data.extra_data.transferable_expires_in
          ),
          legal_term: data.extra_data.legal_term,
        },
      },
    });
  };

  render() {
    const { data, errors, breadcrumbs, loading } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          loading={loading}
          errors={errors}
          edit
          saving={update.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  benefitType: state.benefitsTypes.detail,
  update: state.benefitsTypes.update,
});

const mapActions = (dispatch) =>
  bindActionCreators(BenefitsTypesActions, dispatch);

export default connect(mapState, mapActions)(Edit);
